import firebase from "firebase/app"
import "firebase/database"
import "firebase/auth"
import "firebase/functions"
import "firebase/analytics"

import Config from "config"

// console.log(JSON.stringify(Config, null, 4));

const currentConfig = Config.FirebaseConfig

let firebaseConfig = firebase.initializeApp(currentConfig)
firebase.analytics()
export default firebaseConfig
